import {createFileRoute, useParams} from '@tanstack/react-router';
import React from "react";
import CourtSetupPage from "../../../../bookings/organiser/CourtSetupPage.tsx";

export const Route = createFileRoute('/_app/clubs/$club_uid/court-setup')({
    component: RouteComponent,
});

function RouteComponent() {
    const params = useParams({strict: false});

    return <CourtSetupPage clubUid={params.club_uid} />;
}
